module.exports = __webpack_public_path__ + "static/media/sb-close.30888f37.svg";